import {getOptions} from './format.js';

export const defaultIntelTarget = {
    targetCount: 4,
    options: getOptions(1, 6)
};

export const defaultDesignTarget = {
    targetCount: 1,
    options: getOptions(1, 9)
};

export const warnMessage = {
    message: '当前图片生成提示词未生效，请点击上半部分图片生成里的“开始生成”按钮。',
    duration: 5000
};

export const textAuditRefusedMessage = {
    message: '请合规使用本平台，不支持带有敏感信息的内容输入',
    duration: 5000
};

export const imagePartRefusedMessage = {
    message: '部分敏感信息已被过滤',
    duration: 5000
};

export const placeHolder = {
    page: 'market',
    // subtitle: '快速生成底图，支持叠加营销海报效果',
    image: 'https://feed-image.baidu.com/0/pic/593274118_-2147146569_1892757978.png'
};

export const btbIndustry = [
    '机械设备',
    '化工及能源',
    '农林牧渔',
    '电子电工'
];

export const normalIndustry = [
    '全部行业',
    '房产家居',
    '旅游服务',
    '交通出行',
    '整形美容',
    '教育培训',
    '金融服务',
    '商品交易',
    '医疗服务',
    '生活服务',
    '文娱传媒',
    '商务服务',
    '游戏',
    '软件',
    '网络服务',
    '通信',
    '直营电商',
    '食品饮料',
    '保健品/药品'
];

export const openIndustryByHot = [
    '全部行业',
    '教育培训',
    '文娱传媒',
    '金融服务',
    '生活服务',
    '房产家居',
    '整形美容',
    '商务服务',
    '旅游服务',
    '商品交易',
    '游戏',
    '软件',
    '交通出行',
    '网络服务',
    '机械设备',
    '医疗服务',
    '农林牧渔',
    '通信',
    '化工及能源',
    '电子电工',
    '直营电商',
    '食品饮料',
    '保健品/药品'
];

export const btbIndustryTradeId = [
    2005,
    2029,
    2027,
    2024
];

export const industryTradeIdMap = {
    2001: '3',
    2002: '4',
    2005: '14',
    2006: '7',
    2007: '8',
    2008: '19',
    2010: '13',
    2015: '10',
    2017: '15',
    2018: '16',
    2019: '5',
    2020: '17',
    2022: '9',
    2023: '11',
    2024: '28',
    2025: '29',
    2026: '30',
    2027: '31',
    2029: '20'
};

export const openIndustry = [
    ...normalIndustry,
    ...btbIndustry
];

export const ratioMaxLengthMap = {
    'btb': {
        businessPointB2B: 20,
        sellingPointFirst: 5,
        sellingPointSecond: 5,
        sellingPointThird: 5,
        manufacturerName: 12
    },
    '1:1': {
        mainText: 20,
        descText: 20,
        buttonText: 4,
        otherText: 10
    },
    'base': {
        mainText: 20,
        descText: 20,
        buttonText: 6,
        otherText: 14
    }
};

export const designSizeOptions =  [
    {
        value: '1:1',
        label: '1:1',
        children: [
            {
                value: '600*600',
                label: '600*600'
            }
            // {
            //     value: '240*240',
            //     label: '240*240'
            // }, {
            //     value: '220*220',
            //     label: '220*220'
            // }, {
            //     value: '360*360',
            //     label: '360*360'
            // }, {
            //     value: '480*480',
            //     label: '480*480'
            // }, {
            //     value: '600*600',
            //     label: '600*600'
            // }, {
            //     value: '300*300',
            //     label: '300*300'
            // }
        ]
    }, {
        value: '16:9',
        label: '16:9',
        children: [
            {
                value: '1140*640',
                label: '1140*640'
            }, {
                value: '1280*720',
                label: '1280*720'
            }, {
                value: '1600*900',
                label: '1600*900'
            }, {
                value: '1920*1080',
                label: '1920*1080'
            }, {
                value: '960*540',
                label: '960*540'
            }
        ]
    }, {
        value: '3:4',
        label: '3:4',
        children: [
            {
                value: '750*1000',
                label: '750*1000'
            }
        ]
    }, {
        value: '3:2',
        label: '3:2',
        children: [
            {
                value: '1200*800',
                label: '1200*800'
            }
        ]
    }, {
        value: '3:1',
        label: '3:1',
        children: [
            {
                value: '1200*400',
                label: '1200*400'
            }
        ]
    }, {
        value: '9:16',
        label: '9:16',
        children: [
            {
                value: '1080*1920',
                label: '1080*1920'
            },
            {
                value: '640*1140',
                label: '640*1140'
            }
        ]
    }
];

export const intelSizeOptions = [
    {
        value: '1:1',
        label: '1:1',
        children: [
            {
                value: '1080*1080',
                label: '1080*1080'
            },
            {
                value: '600*600',
                label: '600*600'
            }
            // {
            //     value: '240*240',
            //     label: '240*240'
            // }, {
            //     value: '120*120',
            //     label: '120*120'
            // }, {
            //     value: '80*80',
            //     label: '80*80'
            // }, {
            //     value: '220*220',
            //     label: '220*220'
            // }, {
            //     value: '250*250',
            //     label: '250*250'
            // }, {
            //     value: '360*360',
            //     label: '360*360'
            // }, {
            //     value: '480*480',
            //     label: '480*480'
            // }, {
            //     value: '600*600',
            //     label: '600*600'
            // }, {
            //     value: '300*300',
            //     label: '300*300'
            // }
        ]
    }, {
        value: '2:1',
        label: '2:1',
        children: [
            {
                value: '800*400',
                label: '800*400'
            }, {
                value: '600*300',
                label: '600*300'
            }
        ]
    }, {
        value: '3:2',
        label: '3:2',
        children: [
            {
                value: '1620*1080',
                label: '1620*1080'
            },
            {
                value: '1200*800',
                label: '1200*800'
            }, {
                value: '960*640',
                label: '960*640'
            }, {
                value: '900*600',
                label: '900*600'
            }
            // {
            //     value: '370*245',
            //     label: '370*245'
            // }, {
            //     value: '960*640',
            //     label: '960*640'
            // }, {
            //     value: '378*252',
            //     label: '378*252'
            // }, {
            //     value: '1200*800',
            //     label: '1200*800'
            // }, {
            //     value: '900*600',
            //     label: '900*600'
            // }, {
            //     value: '300*200',
            //     label: '300*200'
            // }
        ]
    }, {
        value: '2:3',
        label: '2:3',
        children: [
            {
                value: '1080*1620',
                label: '1080*1620'
            },
            {
                value: '1242*1863',
                label: '1242*1863'
            }
        ]
    }, {
        value: '3:1',
        label: '3:1',
        children: [
            {
                value: '1200*400',
                label: '1200*400'
            }, {
                value: '1152*384',
                label: '1152*384'
            }, {
                value: '900*300',
                label: '900*300'
            }
        ]
    }, {
        value: '4:3',
        label: '4:3',
        children: [
            {
                value: '1440*1080',
                label: '1440*1080'
            },
            {
                value: '800*600',
                label: '800*600'
            }
            // , {
            //     value: '120*90',
            //     label: '120*90'
            // }
        ]
    }, {
        value: '9:16',
        label: '9:16',
        children: [
            {
                value: '1080*1920',
                label: '1080*1920'
            }, {
                value: '1242*2208',
                label: '1242*2208'
            }, {
                value: '720*1280',
                label: '720*1280'
            }
        ]
    }, {
        value: '16:9',
        label: '16:9',
        children: [
            {
                value: '1920*1080',
                label: '1920*1080'
            }, {
                value: '1140*640',
                label: '1140*640'
            }, {
                value: '1280*720',
                label: '1280*720'
            }, {
                value: '1600*900',
                label: '1600*900'
            }, {
                value: '960*540',
                label: '960*540'
            }
        ]
    }, {
        value: '3:4',
        label: '3:4',
        children: [
            {
                value: '810*1080',
                label: '810*1080'
            },
            {
                value: '750*1000',
                label: '750*1000'
            }
        ]
    }
];

export const inspirationConfig = {
    title: '图片灵感',
    icon: 'filter',
    pageSize: 999,
    imageWidth: 93,
    imageStretchWidth: 98,
    gap: 2,
    loadingText: '加载中...',
    noMoreText: ' 已经到底啦',
    btnText: '生成相似',
    generateBtn: {
        icon: 'image-upload',
        text: '生成相似'
    }
};

export const layoutOptions = [
    {
        value: '',
        label: '全部布局'
    },
    {
        value: '左图右文',
        label: '左图右文'
    },
    {
        value: '左文右图',
        label: '左文右图'
    },
    {
        value: '文字居中',
        label: '文字居中'
    },
    {
        value: '上图下文',
        label: '上图下文'
    },
    {
        value: '上文下图',
        label: '上文下图'
    },
    {
        value: '包框类型',
        label: '包框类型'
    }
];

export const colorOptions = [
    {
        value: '',
        label: '全部色系'
    }, {
        value: '红色',
        label: '红色'
    }, {
        value: '黄色',
        label: '黄色'
    }, {
        value: '橙色',
        label: '橙色'
    }, {
        value: '绿色',
        label: '绿色'
    }, {
        value: '蓝色',
        label: '蓝色'
    }, {
        value: '紫色',
        label: '紫色'
    }, {
        value: '金色',
        label: '金色'
    }, {
        value: '灰色',
        label: '灰色'
    }, {
        value: '白色',
        label: '白色'
    }, {
        value: '黑色',
        label: '黑色'
    }, {
        value: '棕色',
        label: '棕色'
    }, {
        value: '青色',
        label: '青色'
    }, {
        value: '粉色',
        label: '粉色'
    }
];

export const sortOptions = [
    {
        value: 'DEFAULT',
        label: '智能排序'
    },
    {
        value: 'COLLECT',
        label: '我的收藏'
    },
    {
        value: 'UPDATE_TIME',
        label: '最新'
    },
    {
        value: 'ACCEPT_COUNT',
        label: '最热'
    }
];

export const secondaryIndustryOptions = [
    {
        label: '全部行业',
        value: 'ALL',
        index: 0
    },
    {
        label: '教育培训',
        value: 5,
        index: 5,
        options: [
            {
                label: 'K12教育',
                value: 'K12教育'
            },
            {
                label: '出国留学',
                value: '出国留学'
            },
            {
                label: '教育培训-其他',
                value: '教育培训-其他'
            },
            {
                label: '少儿兴趣培训',
                value: '少儿兴趣培训'
            },
            {
                label: '特殊教育',
                value: '特殊教育'
            },
            {
                label: '学历教育',
                value: '学历教育'
            },
            {
                label: '语言培训',
                value: '语言培训'
            },
            {
                label: '职业培训',
                value: '职业培训'
            }
        ]
    },
    {
        label: '医疗服务',
        value: 3,
        index: 3,
        options: [
            {
                label: '中医科',
                value: '中医科'
            },
            {
                label: '内科',
                value: '内科'
            },
            {
                label: '皮肤科',
                value: '皮肤科'
            },
            {
                label: '综合医院',
                value: '综合医院'
            },
            {
                label: '儿科',
                value: '儿科'
            },
            {
                label: '医疗周边服务',
                value: '医疗周边服务'
            },
            {
                label: '生殖医学科',
                value: '生殖医学科'
            },
            {
                label: '妇产科',
                value: '妇产科'
            },
            {
                label: '眼科',
                value: '眼科'
            },
            {
                label: '男科',
                value: '男科'
            },
            {
                label: '外科',
                value: '外科'
            },
            {
                label: '精神科',
                value: '精神科'
            },
            {
                label: '耳鼻咽喉科',
                value: '耳鼻咽喉科'
            },
            {
                label: '口腔科',
                value: '口腔科'
            }
        ]
    },
    {
        label: '金融服务',
        value: 10,
        index: 10,
        options: [
            {
                label: '保险业',
                value: '保险业'
            },
            {
                label: '贷款平台',
                value: '贷款平台'
            },
            {
                label: '典当',
                value: '典当'
            },
            {
                label: '交易平台',
                value: '交易平台'
            },
            {
                label: '金融征信',
                value: '金融征信'
            },
            {
                label: '期货业',
                value: '期货业'
            },
            {
                label: '证券业',
                value: '证券业'
            }
        ]
    },
    {
        label: '生活服务',
        value: 8,
        index: 8,
        options: [
            {
                label: '便民回收',
                value: '便民回收'
            },
            {
                label: '国学业务',
                value: '国学业务'
            },
            {
                label: '婚恋相亲',
                value: '婚恋相亲'
            },
            {
                label: '家政服务',
                value: '家政服务'
            },
            {
                label: '居民维修',
                value: '居民维修'
            },
            {
                label: '开锁配钥',
                value: '开锁配钥'
            },
            {
                label: '丧葬业务',
                value: '丧葬业务'
            },
            {
                label: '体育演出场馆',
                value: '体育演出场馆'
            },
            {
                label: '心理援助',
                value: '心理援助'
            },
            {
                label: '月子中心（非医疗机构）',
                value: '月子中心（非医疗机构）'
            }
        ]
    },
    {
        label: '房产家居',
        value: 11,
        index: 11,
        options: [
            {
                label: '装修建材',
                value: '装修建材'
            },
            {
                label: '装潢装修',
                value: '装潢装修'
            },
            {
                label: '家具家居',
                value: '家具家居'
            },
            {
                label: '房产中介',
                value: '房产中介'
            },
            {
                label: '房地产开发商',
                value: '房地产开发商'
            }
        ]
    },
    {
        label: '整形美容',
        value: 4,
        index: 4,
        options: [
            {
                label: '口腔美容',
                value: '口腔美容'
            },
            {
                label: '面部整形',
                value: '面部整形'
            },
            {
                label: '皮肤美容',
                value: '皮肤美容'
            },
            {
                label: '整形美容综合',
                value: '整形美容综合'
            },
            {
                label: '植发',
                value: '植发'
            }
        ]
    },
    {
        label: '商务服务',
        value: 7,
        index: 7,
        options: [
            {
                label: '法律服务',
                value: '法律服务'
            },
            {
                label: '代理代办',
                value: '代理代办'
            },
            {
                label: '广告服务',
                value: '广告服务'
            },
            {
                label: '检测认证',
                value: '检测认证'
            },
            {
                label: '安全安保',
                value: '安全安保'
            },
            {
                label: '签证服务',
                value: '签证服务'
            },
            {
                label: '包装印刷',
                value: '包装印刷'
            },
            {
                label: '咨询调查',
                value: '咨询调查'
            },
            {
                label: '商务服务-其他',
                value: '商务服务-其他'
            },
            {
                label: '技术服务',
                value: '技术服务'
            },
            {
                label: '出国移民',
                value: '出国移民'
            },
            {
                label: '招聘/人才中介',
                value: '招聘/人才中介'
            }
        ]
    },
    {
        label: '旅游服务',
        value: 17,
        index: 17,
        options: [
            {
                label: '景点',
                value: '景点'
            },
            {
                label: '酒店',
                value: '酒店'
            },
            {
                label: '旅行社',
                value: '旅行社'
            },
            {
                label: '商旅票务',
                value: '商旅票务'
            },
            {
                label: '在线旅游',
                value: '在线旅游'
            }
        ]
    },
    {
        label: '商品交易',
        value: 9,
        index: 9
    },
    {
        label: '游戏',
        value: 16,
        index: 16
    },
    {
        label: '软件',
        value: 15,
        index: 15,
        options: [
            {
                label: '多媒体处理',
                value: '多媒体处理'
            },
            {
                label: '软件平台',
                value: '软件平台'
            },
            {
                label: '商用软件',
                value: '商用软件'
            },
            {
                label: '社交通讯',
                value: '社交通讯'
            },
            {
                label: '实用工具',
                value: '实用工具'
            }
        ]
    },
    {
        label: '交通出行',
        value: 13,
        index: 13
    },
    {
        label: '网络服务',
        value: 30,
        index: 30
    },
    {
        label: '机械设备',
        value: 14,
        index: 14
    },
    {
        label: '农林牧渔',
        value: 31,
        index: 31
    },
    {
        label: '通信',
        value: 29,
        index: 29
    },
    {
        label: '化工及能源',
        value: 20,
        index: 20
    },
    {
        label: '电子电工',
        value: 28,
        index: 28
    },
    {
        label: '直营电商',
        value: 34,
        index: 34
    },
    {
        label: '食品饮料',
        value: 25,
        index: 25
    },
    {
        label: '保健品/药品',
        value: 22,
        index: 22
    },
    {
        label: '文娱传媒',
        value: 19,
        index: 19
    }
];

export const cultureIndustryOptions = {
    label: '文创团队',
    value: '文创整图模版',
    options: [
        {
            label: '金融服务',
            value: 'INDUSTRY:10'
        },
        {
            label: '房产家居',
            value: 'INDUSTRY:11'
        },
        {
            label: '游戏',
            value: 'INDUSTRY:16'
        },
        {
            label: '交通出行',
            value: 'INDUSTRY:13'
        },
        {
            label: '旅游服务',
            value: 'INDUSTRY:17'
        },
        {
            label: '商务服务',
            value: 'INDUSTRY:7'
        },
        {
            label: '软件',
            value: 'INDUSTRY:15'
        },
        {
            label: '化工及能源',
            value: 'INDUSTRY:20'
        }
    ]
};

export const submitTipObj = {
    leftText: '一键出图支持生成底图后套用模版；如需要单独使用模版，可使用',
    text: '模版制图',
    rightText: '功能',
    routeName: 'templateV2'
};